import Project from "./Project.js";
import * as THREE from "three";
import gsap from 'gsap';

/**
 * @abstract
 */
export class SectionBase {
    constructor(_options) {
        this.time = _options.time
        this.resources = _options.resources
        this.camera = _options.camera
        this.passes = _options.passes
        this.objects = _options.objects
        this.areas = _options.areas
        this.walls = _options.walls
        this.zones = _options.zones
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y
        // Debug
        if(this.debug) {
            this.debugFolder = this.debug.addFolder('projects')
            this.debugFolder.open()
        }

        this.items = []

        this.interDistance = 24
        this.positionRandomess = 5
        this.projectHalfWidth = 9

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        this.container.updateMatrix()

        this.setGeometries()
        this.setMeshes()
        this.setItemConfigs()
        this.setZone()
        this.setWalls()
        this.setRoads()
        this.setStatic()

        for(const item of this.list)
        {
            this.add(item)
        }
    }

    /**
     * @abstract
     */
    setGeometries() {
    }

    /**
     * @abstract
     */
    setMeshes() {
    }

    /**
     * @abstract
     */
    setItemConfigs() {
        this.list = []
    }

    /**
     * @abstract
     */
    setWalls(){
        this.dikes = {}
        this.dikes.brickOptions = {
            base: this.resources.items.brickBase.scene,
            collision: this.resources.items.brickCollision.scene,
            offset: new THREE.Vector3(0, 0, 0.1),
            rotation: new THREE.Euler(0, 0, 0),
            duplicated: true,
            shadow: { sizeX: 1.2, sizeY: 1.8, offsetZ: - 0.15, alpha: 0.35 },
            mass: 0.5,
            soundName: 'brick'
        }
    }

    /**
     * @abstract
     */
    setRoads() {
    }

    /**
     * @abstract
     */
    setStatic() {
    }

    add(item) {
        // Falls x oder y im Projekt definiert ist, nimm sie – sonst Standard-Offset
        const x = typeof item.x === 'number' ? item.x : this.x + this.items.length * this.interDistance
        const y = typeof item.y === 'number' ? item.y : this.y + (Math.random() - 0.5) * this.positionRandomess

        // Create project
        const project = new Project({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            debug: this.debugFolder,
            interactionType: item.interactionType,
            x: x,
            y: y,
            ...item
        })

        this.container.add(project.container)

        this.setZone(x, y, item.cameraAngle || 'default')

        // Add tiles
        if (this.items.length >= 1 && (!item.useTiles)) {
            const previousProject = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousProject.x + 7, previousProject.y)
            const end = new THREE.Vector2(project.x - this.projectHalfWidth, project.y)
            const delta = end.clone().sub(start)
            this.tiles.add({
                start: start,
                delta: delta
            })
        }

        // Save
        this.items.push(project)
    }

    setZone(x, y, cameraAngle = 'default') {
        const totalWidth = this.list.length * (this.interDistance / 2)
        const zone = this.zones.add({
            position: {x: x + 2, y: y},
            halfExtents: {x: 12, y: 10},
            data: {cameraAngle: cameraAngle}
        })
        zone.on('in', (_data) => {
            this.camera.angle.set(_data.cameraAngle)
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, {x: 0, duration: 2})
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, {y: 0, duration: 2})
        })
        zone.on('out', () => {
            this.camera.angle.set('default')
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, {
                x: this.passes.horizontalBlurPass.strength,
                duration: 2
            })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, {
                y: this.passes.verticalBlurPass.strength,
                duration: 2
            })
        })
    }
}